import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import balanceService from "../../services/balance-service";
import {BalanceState, handleBalanceChange, handleBindingChange} from "../reducers/balance-reducers";

export const getCurrentBalance = createAsyncThunk(
    'getCurrentBalance',
    async () => {
        const result =  await balanceService.getMyBalance();
        const balance = result?.data;
        return {balance};
    },
    {
        condition(thunkData, {getState}): boolean {
            const state = getState() as BalanceState;
            return !(state.balance && state.balance.length);
        }
    }
)

export const validateBalance = createAsyncThunk(
    'validateBalance',
    async (props: {paymentId: string, paymentTypeId: number, paymentMethod: number, currency: number}) => {
        const result =  await balanceService.validateBalance(props.paymentId, props.paymentTypeId,  props.paymentMethod, props.currency);
        const balance = result?.data;
        return {balance};
    },
    {
        condition(thunkData, {getState}): boolean {
            const state = getState() as BalanceState;
            return !(state.balance && state.balance.length);
        }
    }
)

export const getBindings = createAsyncThunk(
    'getBindings',
    async () => {
        const bindings =  await balanceService.getBindings();
        const result = bindings?.data;
        return {result};
    },
    {
        condition(thunkData, {getState}): boolean {
            const state = getState() as BalanceState;
            return !(state.bindings && state.bindings.length);
        }
    }
)

export const balanceSlice = createSlice({
    name: "balanceData",
    initialState: {
        balance: [] = [],
        bonus: [] = [],
        bindings: [] = []
    } as BalanceState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder.addCase(getCurrentBalance.fulfilled, (state, action) => handleBalanceChange(state, action.payload));
        builder.addCase(validateBalance.fulfilled, (state, action) => handleBalanceChange(state, action.payload));
        builder.addCase(getBindings.fulfilled, (state, action) => handleBindingChange(state, action.payload));
    }
})

export default balanceSlice.reducer;
